/* =========================================================
   PhoneCircle – All-in-one Accessibility Auto-Fixes
   For the Lighthouse / PageSpeed "Agentic Browsing" + standard
   Accessibility audits. Add this ONE file to your store.

   This replaces the separate snippets from before:
     - a11y-svg-autofix.js
     - a11y-redundant-alt-fix.js
     - a11y-add-missing-alt.js
   Delete those and use only this file.

   WHAT IT FIXES (runtime)
     1. SVG icons with no title/label  -> hidden as decorative
     2. Links / buttons with no text   -> given an aria-label
     3. Images with NO alt attribute   -> given a sensible alt
     4. Images whose alt duplicates nearby text -> alt emptied (safe)

   WHAT IT DOES NOT FIX (must be done in Shopify theme settings)
     - Colour contrast  -> Theme editor > Theme settings > Colours
     - Render-blocking CSS -> mostly a Shopify/Lighthouse limitation

   HOW TO ADD (Shopify)
     - Themes > Edit code > Assets > open "a11y-svg-autofix.js"
       (or create it). Replace ALL its contents with this file. Save.
     - Make sure theme.liquid loads it before </body>:
         <script src="{{ 'a11y-svg-autofix.js' | asset_url }}" defer></script>
   ========================================================= */

(function () {
  // Meaningful graphics -> real name instead of being hidden.
  // key = svg id, value = text to announce. Edit as needed.
  const MEANINGFUL_SVGS = {
    "Capa_1": "PhoneCircle logo",
  };

  const norm = (s) => (s || "").replace(/\s+/g, " ").trim();
  const lower = (s) => norm(s).toLowerCase();

  /* 1. SVGs ------------------------------------------------ */
  function fixSvgs() {
    document.querySelectorAll("svg").forEach((svg) => {
      const role = (svg.getAttribute("role") || "").toLowerCase();
      const named =
        svg.querySelector("title") ||
        svg.getAttribute("aria-label") ||
        svg.getAttribute("aria-labelledby");
      const decorative =
        role === "presentation" ||
        role === "none" ||
        svg.getAttribute("aria-hidden") === "true";
      if (named || decorative) return;

      const label = MEANINGFUL_SVGS[svg.id];
      if (label) {
        svg.setAttribute("role", "img");
        svg.setAttribute("aria-label", label);
      } else {
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
      }
    });
  }

  /* 2. Images: add missing alt ----------------------------- */
  function fromFilename(img) {
    try {
      const src = img.currentSrc || img.src || "";
      let file = src.split("?")[0].split("/").pop() || "";
      file = file.replace(/\.[a-z0-9]+$/i, "");
      file = file.replace(/[-_]+/g, " ").replace(/\d+/g, " ");
      file = norm(file);
      return file.length >= 3 ? file : "";
    } catch (e) {
      return "";
    }
  }
  function deriveAlt(img) {
    const hint = norm(
      img.getAttribute("data-alt") ||
      img.getAttribute("data-title") ||
      img.getAttribute("title")
    );
    if (hint) return hint;

    const link = img.closest("a, button");
    if (link) {
      const lt = norm(link.getAttribute("aria-label") || link.textContent);
      if (lt) return lt;
    }
    const card =
      img.closest("li, figure, .card, .grid__item, [class*='card'], [class*='item']") ||
      img.parentElement;
    if (card) {
      const h = card.querySelector(
        "h1,h2,h3,h4,h5,h6,figcaption,[class*='title'],[class*='heading']"
      );
      if (h) {
        const ht = norm(h.textContent);
        if (ht) return ht;
      }
    }
    return fromFilename(img);
  }
  function addMissingAlt() {
    document.querySelectorAll("img:not([alt])").forEach((img) => {
      img.setAttribute("alt", deriveAlt(img)); // "" if nothing -> decorative
    });
  }

  /* 3. Images: empty redundant alt ------------------------- */
  function fixRedundantAlt() {
    document.querySelectorAll("img[alt]").forEach((img) => {
      const alt = lower(img.getAttribute("alt"));
      if (!alt) return;
      const link = img.closest("a");
      const card =
        img.closest("a, li, .card, .collection-card, [class*='card']") ||
        img.parentElement;
      if (!card) return;
      const cardText = lower(card.textContent);
      if (cardText && cardText.indexOf(alt) !== -1) {
        const linkText = link ? lower(link.textContent) : cardText;
        if (linkText) img.setAttribute("alt", "");
      }
    });
  }

  /* 4. Links / buttons with no name ------------------------ */
  function fixLinks() {
    document.querySelectorAll("a[href], button").forEach((el) => {
      const hasText = norm(el.textContent).length > 0;
      if (
        hasText ||
        el.getAttribute("aria-label") ||
        el.getAttribute("aria-labelledby") ||
        el.getAttribute("title")
      )
        return;
      const img = el.querySelector("img");
      if (img && norm(img.getAttribute("alt"))) return;

      let label =
        (img && img.getAttribute("alt")) ||
        el.getAttribute("data-product-title") ||
        "";
      if (!label && el.classList.contains("jdgm-carousel-item__product"))
        label = "View product";
      if (!label) label = "Link";
      el.setAttribute("aria-label", label);
    });
  }

  function run() {
    fixSvgs();
    addMissingAlt();
    fixRedundantAlt();
    fixLinks(); // last, so emptied alts that leave a link unnamed get caught
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  // Re-run after late-loading content (Judge.me carousel, apps).
  window.addEventListener("load", function () {
    setTimeout(run, 1500);
  });
})();
